import React from 'react';
import { Link } from 'react-router-dom';
import OasisMark from '../common/OasisMark';

// The only site-wide link surface -- the header has just logo/login/register --
// so every public route needs an entry here or it is orphaned. No noindex
// routes: linking /portfolio site-wide spent link equity on a page that cannot
// rank. src/seo/internal-links.test.ts enforces both.
const FOOTER_SECTIONS = [
  {
    title: 'Döviz',
    links: [
      { to: '/doviz-cevirici', label: 'Döviz Çevirici' },
      { to: '/instrument/USDTRY=X', label: 'Dolar Kuru' },
      { to: '/instrument/EURTRY=X', label: 'Euro Kuru' },
    ],
  },
  {
    title: 'Altın',
    links: [
      { to: '/altin', label: 'Altın Fiyatları' },
      { to: '/altin-hesaplama', label: 'Altın Hesaplama' },
      { to: '/instrument/gram_altin', label: 'Gram Altın' },
    ],
  },
  {
    title: 'Borsa',
    links: [
      { to: '/bist', label: 'BIST 100 Hisseleri' },
      { to: '/us-stocks', label: 'US Hisseleri' },
      { to: '/all-stocks', label: 'Tüm Hisseler' },
      { to: '/temettu-hisseleri', label: 'Temettü Hisseleri' },
    ],
  },
  {
    title: 'Piyasa',
    links: [
      { to: '/crypto', label: 'Kripto Paralar' },
      { to: '/news', label: 'Finansal Haberler' },
      { to: '/ekonomik-takvim', label: 'Ekonomik Takvim' },
      { to: '/forum', label: 'Forum' },
    ],
  },
];

const Footer: React.FC = () => {
  return (
    <footer className="border-t border-white/[0.06] bg-canvas">
      <div className="container-financial py-10">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-8 mb-8">
          {/* Brand */}
          <div className="col-span-2">
            <div className="flex items-center gap-2.5 mb-3">
              <OasisMark className="w-7 h-7 text-accent-400" />
              <span className="text-sm font-semibold tracking-tight select-none">
                <span className="text-white">Oasis</span>
                <span className="text-accent-400">Finans</span>
              </span>
            </div>
            <p className="text-xs text-gray-500 leading-relaxed max-w-[220px]">
              Döviz, altın ve borsa verilerini tek ekrandan takip edin.
            </p>
          </div>

          {FOOTER_SECTIONS.map((section) => (
            <div key={section.title}>
              <h3 className="text-[11px] font-semibold uppercase tracking-[0.12em] text-gray-500 mb-3">
                {section.title}
              </h3>
              <ul className="space-y-2">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link to={link.to} className="text-[13px] text-gray-400 hover:text-white transition-colors">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-white/[0.06] pt-5">
          <p className="text-[11px] text-gray-600 leading-relaxed mb-4">
            OasisFinans'ta yer alan veriler ve kullanıcı yorumları yatırım danışmanlığı kapsamında
            değildir. Veriler üçüncü taraf kaynaklardan sağlanır; gecikmeli veya hatalı olabilir ve
            alım satım işlemlerine dayanak oluşturmaz. Ayrıntılar için{' '}
            <Link to="/yasal-uyari" className="underline hover:text-gray-300 transition-colors">Yasal Uyarı</Link>{' '}
            sayfasını inceleyin.
          </p>
          <div className="flex flex-col sm:flex-row justify-between items-center gap-2 text-xs text-gray-600">
            <span className="text-num">© 2026 OasisFinans</span>
            <div className="flex gap-5">
              <Link to="/yasal-uyari" className="hover:text-gray-300 transition-colors">Yasal Uyarı</Link>
              <Link to="/privacy-policy" className="hover:text-gray-300 transition-colors">Gizlilik Politikası</Link>
              <Link to="/feedback" className="hover:text-gray-300 transition-colors">İletişim</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
